import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Slide } from '@mui/material';

const COOKIE_KEY = 'cookie_consent';

const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setOpen(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <Box sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        bgcolor: 'background.paper',
        color: 'text.primary',
        boxShadow: 6,
        zIndex: 2000,
        p: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}>
        <Typography variant="body2" sx={{ flex: 1, textAlign: 'center' }}>
          This app uses cookies for essential functionality. By using this site, you agree to our <a href="/privacy" style={{ color: '#0072CE', textDecoration: 'underline' }}>Privacy Policy</a>.
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAccept} sx={{ minWidth: 120 }}>
          Accept
        </Button>
      </Box>
    </Slide>
  );
};

export default CookieConsent;
